import { DomainModelMetaDataInterface, ModelInterface, ModifiedSubscriberInterface, PropertyMetaDataInterface, ViewModelEventDispatcherInterface, ViewModelInterface } from '@nts/std/interfaces';

export class PropertyViewModelInitializationInfo {
    propertyName: string;
    model: ModelInterface;
    domainModelMetadata: DomainModelMetaDataInterface;
    propertyMetaData: PropertyMetaDataInterface;
    eventDispatcher: ViewModelEventDispatcherInterface;
    modifiedSubscriber: ModifiedSubscriberInterface;
    isCustom: boolean;
    useMessageResourceKey: boolean;
    parent: ViewModelInterface;

    customGetter?: () => any;
    customSetter?: (x: any) => Promise<void>;

    // Viene utilizzata come property nei custom getter/custom setter di default
    customValue?: any;
    path: string;
}
